<template>
    <div>
        <MenuStorage/>
        <Bin_stock/>
    </div>
</template>

<script>
    import MenuStorage from "@/components/admin/stock/menustorage/MenuStorage.vue";
    import Bin_stock from "@/components/admin/stock/storage_bins/Bin_stock.vue";
    export default {
        name: "BinStorage",
        components: {
            Bin_stock,
            MenuStorage
        }
    }
</script>

<style scoped>

</style>
